// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoadingOverlay from "./features/ui/LoadingOverlay";
import LoginPage from "./pages/LoginPage";
import CallbackPage from "./pages/CallbackPage";
import HomePage from "./pages/HomePage";
import WorksheetDetailPage from "./pages/WorksheetDetailPage";

function App() {
  return (
    <Router>
      <LoadingOverlay>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route
            path="/worksheet/:type/:id"
            element={<WorksheetDetailPage />}
          />
          <Route path="*" element={<LoginPage />} />
        </Routes>
      </LoadingOverlay>
    </Router>
  );
}

export default App;
